import { createContext, useContext, type ReactNode } from "react";
import type { SiteSettings } from "@akhshy/types";
import { client } from "./api.ts";
import { useAsync, type AsyncState } from "./useAsync.ts";
import { FALLBACK_SETTINGS } from "./fallback.ts";

export interface SiteData {
  settings: AsyncState<SiteSettings>;
}

const DataContext = createContext<SiteData | null>(null);

export function DataProvider({ children }: { children: ReactNode }) {
  const value: SiteData = {
    settings: useAsync(() => client.settings.get(), []),
  };
  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
}

function useData(): SiteData {
  const ctx = useContext(DataContext);
  if (!ctx) throw new Error("useData must be used within DataProvider");
  return ctx;
}

/** Settings is a singleton; list content is now paginated per-section. */
export function useSettings() {
  const { settings } = useData();
  return { ...settings, value: settings.data ?? FALLBACK_SETTINGS };
}
